<template><section><h1>Spinner</h1>
<blockquote>
<p>加载动画</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>size</td>
<td style="text-align:left">尺寸</td>
<td><code>Number</code></td>
<td><code>24</code></td>
</tr>
<tr>
<td>color</td>
<td style="text-align:left">颜色</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>wrap</td>
<td style="text-align:left">是否覆盖整个容器</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Spinner.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-4.vue?29a0f249